export const enum FileDocumentTypes {
  ClientDocs = "ClientDocs",
  SupplierDocs = "SupplierDocs",
  CaseFile = "CaseFile",
  UserImage = "UserImage",
  Posting = "Posting",
}
